import React, { useState } from "react";
import { IoMdCloseCircle } from "react-icons/io";
import ReactImageGallery from "react-image-gallery";

type Props = {
  gallery: string[];
};

const getType = (src: string) => {
  return src.endsWith("mp4") || src.endsWith("webm") ? "video" : "image";
};

const getExtension = (src: string) => {
  const parts = src.split(".");
  const extension = parts[parts.length - 1];

  return extension;
};

export const GalleryTab: React.FC<Props> = ({ gallery }) => {
  const [showGalleryModal, setShowGalleryModal] = useState(false);
  const [galleryStartIndex, setGalleryStartIndex] = useState(0);

  const onThumbnailClick = (i: number) => {
    setGalleryStartIndex(i);
    setShowGalleryModal(true);
  };

  return (
    <div>
      {(gallery.length === 0) && (
        <div className="text-gray-500 text-sm">Brak zdjęć w galerii</div>
      )}
      {showGalleryModal && (
        <div
          style={{ zIndex: 9997, backgroundColor: "rgba(0,0,0,0.7)" }}
          className="top-0 bottom-0 left-0 right-0 fixed  w-full h-full "
        >
          <div
            className="absolute cursor-pointer"
            onClick={() => setShowGalleryModal(false)}
            style={{
              zIndex: 9998,
              right: 40,
              top: 40,
            }}
          >
            <IoMdCloseCircle
              className="text-white hover:text-blue-600"
              size={40}
            />
          </div>
          {!!gallery && (
            <div style={{ zIndex: 9999 }}>
              <ReactImageGallery
                startIndex={galleryStartIndex}
                renderThumbInner={(item) => {
                  const type = getType(item.thumbnail!);
                  const extension = getExtension(item.thumbnail!);

                  return (
                    <div className="w-34 h-20 flex bg-white">
                      {type === "image" && (
                        <img
                          src={item.thumbnail}
                          className=" object-contain mx-auto"
                        />
                      )}
                      {type === "video" && (
                        <video>
                          <source
                            src={item.thumbnail}
                            type={`${type}/${extension}`}
                          />
                        </video>
                      )}
                    </div>
                  );
                }}
                renderFullscreenButton={() => null}
                renderPlayPauseButton={() => null}
                renderItem={(item) => {
                  const type = getType(item.original!);
                  const extension = getExtension(item.original!);

                  return (
                    <div
                      className="flex justify-center items-center"
                      style={{ height: "88vh" }}
                    >
                      {type === "image" && (
                        <img
                          src={item.original}
                          className="max-w-full max-h-full md:max-h-96"
                          // style={{ maxHeight: '50%' }}
                        />
                      )}
                      {type === "video" && (
                        <video autoPlay controls>
                          <source
                            src={item.original}
                            type={`${type}/${extension}`}
                          />
                        </video>
                      )}
                    </div>
                  );
                }}
                items={gallery.map((src: string) => ({
                  original: src,
                  thumbnail: src,
                  thumbnailClass: "w-32",
                }))}
              />
            </div>
          )}
        </div>
      )}
      <div className="flex flex-wrap">
        {gallery.map((src: string, i: number) => {
          const type =
            src.endsWith("mp4") || src.endsWith("webm") ? "video" : "image";
          const srcParts = src.split(".");
          const extension = srcParts[srcParts.length - 1];

          return (
            <div
              onClick={() => onThumbnailClick(i)}
              className="w-32 h-20 flex justify-center cursor-pointer border-2 border-white hover:border-blue-600"
            >
              {type === "image" && (
                <img className=" object-contain" src={src} />
              )}
              {type === "video" && (
                <video className="object-contain">
                  <source type={`video/${extension}`} src={src} />
                </video>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
